/* globals google */

import Vue from 'vue'
import App from './App.vue'
import store from './store';
import * as VueGoogleMaps from 'vue2-google-maps'
import './registerServiceWorker'
import inViewportDirective from 'vue-in-viewport-directive'
import ComponentSystem from 'components-system';
import 'components-system/dist/components-system.css';
import Vuetify, { VApp, VMain, VBtn, VImg, VAvatar, VLazy, VSnackbar, VDialog, VSpacer, VCard, VCardTitle, VCardText, VCardActions, VToolbar, VBottomSheet, VIcon, VToolbarTitle, VToolbarItems, VForm, VCarousel, VCarouselItem, VProgressCircular } from 'vuetify/lib'
import Vuebar from 'vuebar';
Vue.use(Vuebar);

Vue.use(Vuetify, {
  components: {
    VApp, VMain,
    VBtn, VImg, VAvatar,
    VLazy, VSnackbar, VDialog, VSpacer,
    VCard, VCardTitle, VCardActions, VCardText,
    VToolbar, VBottomSheet, VIcon,
    VToolbarTitle, VForm, VToolbarItems,
    VCarousel, VCarouselItem, VProgressCircular
  }
})
Vue.use(ComponentSystem);
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.GOOGLE_MAP_API_KEY,
  }
});

Vue.directive('in-viewport', inViewportDirective)

if (process.env.NODE_ENV === 'production') {
  console.info('Production');
}
Vue.config.productionTip = process.env.NODE_ENV === 'production';

const vuetify = new Vuetify({})

new Vue({
  render: h => h(App),
  vuetify,
  store
}).$mount('#app')

window.googleTranslateElementInit = () => {
  new google.translate.TranslateElement({ pageLanguage: 'en' }, 'google_translate_element');
};

// window.addEventListener('beforeinstallprompt', (e) => {
//   // Prevent Chrome 67 and earlier from automatically showing the prompt
//   e.preventDefault();
//   // Stash the event so it can be triggered later.
//   deferredPrompt = e;
//   // Update UI to notify the user they can add to home screen
//   addBtn.style.display = 'block';

//   addBtn.addEventListener('click', (e) => {
//     // hide our user interface that shows our A2HS butt
//     addBtn.style.display = 'none';
//     // Show the prompt
//     deferredPrompt.prompt();
//     // Wait for the user to respond to the prompt
//     deferredPrompt.userChoice.then((choiceResult) => {
//         if (choiceResult.outcome === 'accepted') {
//           console.log('User accepted the A2HS prompt');
//         } else {
//           console.log('User dismissed the A2HS prompt');
//         }
//         deferredPrompt = null;
//       });
//   });
// });

